// extracted by mini-css-extract-plugin
export default {"main":"notfound_main__bFeUj","blue_button":"notfound_blue_button__N9k3I","error_img":"notfound_error_img__mjp3X"};